
export default function AboutHeroSection() {
  return (
    <section 
      id="hero"
      className="relative min-h-[70vh] flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/4c1a83e94007d40f5b63623131917570.jpg')`
      }}
    >
      <div className="container mx-auto px-6 relative z-10">
        <div className="w-full text-center">
          <div className="space-y-8">
            <h1 className="text-2xl md:text-4xl lg:text-6xl font-bold text-white leading-tight">
              关于南滇古茶
              <span className="block text-blue-400 mt-2">传承千年茶文化</span>
            </h1>
            
            <p className="text-base md:text-xl lg:text-2xl text-white/90 leading-relaxed max-w-4xl mx-auto">
              深耕云南茶叶产业15年，致力于打造中国最具影响力的茶叶品牌
              <br />
              从古茶山到现代工艺，我们坚持品质与传承并重
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
              <button className="bg-blue-500 hover:bg-blue-600 text-white px-8 py-4 rounded-full font-semibold text-sm md:text-lg transition-all duration-300 transform hover:scale-105 cursor-pointer whitespace-nowrap">
                <i className="ri-book-open-line mr-2"></i>
                了解我们的故事
              </button>
              <button className="border-2 border-white text-white hover:bg-white hover:text-gray-800 px-8 py-4 rounded-full font-semibold text-sm md:text-lg transition-all duration-300 cursor-pointer whitespace-nowrap">
                <i className="ri-map-pin-line mr-2"></i>
                参观茶园基地
              </button>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto mt-12">
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 text-center">
                <div className="text-xl md:text-2xl lg:text-3xl font-bold text-blue-400 mb-1">15+</div>
                <div className="text-white text-xs md:text-sm">发展年限</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 text-center">
                <div className="text-xl md:text-2xl lg:text-3xl font-bold text-blue-400 mb-1">50000+</div>
                <div className="text-white text-xs md:text-sm">茶园面积(亩)</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 text-center">
                <div className="text-xl md:text-2xl lg:text-3xl font-bold text-blue-400 mb-1">300+</div>
                <div className="text-white text-xs md:text-sm">合作伙伴</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 text-center">
                <div className="text-xl md:text-2xl lg:text-3xl font-bold text-blue-400 mb-1">100万+</div>
                <div className="text-white text-xs md:text-sm">服务客户</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
